import script from "./DialogDetailService.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogDetailService.vue?vue&type=script&setup=true&lang=js"

import "./DialogDetailService.vue?vue&type=style&index=0&id=5f0eadf2&lang=scss"

const __exports__ = script;

export default __exports__